export default __webpack_public_path__ + "static/media/wife-and-cat-md-2x.a68a70da.jpg";